module.exports = __webpack_public_path__ + "images/b1be06d828541a682190e14f72c0204c.png";